import React from "react";
import { Redirect } from "react-router-dom";
import tokenService from "utils/tokenService";

const RequiredAuth = (ComposedComponent) => (props) => {
  const TokenService = tokenService.getService();
  return (
    <>
      {TokenService.getRefreshToken() ? (
        <ComposedComponent {...props} />
      ) : (
        <Redirect to="/login" />
      )}
    </>
  );
};
export default RequiredAuth;
